module.exports = __webpack_public_path__ + "static/media/bones.72ce7864.svg";